let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("35kMw")).then(() => parcelRequire('iWm1r'));